// @module Ames.CustomMerchantZone.CustomMerchantZone
define("Ames.CustomMerchantZone.CustomMerchantZone.View", [
  "ames_custommerchantzone_custommerchantzone.tpl",

  "Ames.CustomMerchantZone.CustomMerchantZone.SS2Model",

  "Backbone",

  "CustomContentType.Base.View",

  "Item.Model",

  "CustomMerchantZone.Confirmation.View",

  "CustomMerchantZone.MoreItems.View",
], function (
  ames_custommerchantzone_custommerchantzone_tpl,
  CustomMerchantZoneSS2Model,
  Backbone,
  CustomContentTypeBaseView,
  ItemModel,
  CustomMerchantZoneConfirmationView,
  CustomMerchantZoneMoreItemsView,
) {
  "use strict";

  return CustomContentTypeBaseView.extend({
    template: ames_custommerchantzone_custommerchantzone_tpl,

    // Swipe tracking properties
    touchStartX: 0,
    touchStartY: 0,
    touchEndX: 0,
    touchEndY: 0,

    // how many per page
    itemsPerPage: 24,
    // start on page 1
    currentPage: 1,

    install: function install(settings, context_data) {
      setInterval(function () {
        if (this.initHeroCarousel()) {
          clearInterval(t);
        }
      }, 100);
      this.itemModel = new ItemModel();
      var cmsitems = settings.custrecord_merchant_items.split("\u0005");
      this.model = new CustomMerchantZoneSS2Model();
      this.commerceCategory = settings.custrecord_commerce_category || "";
      this.orderItems = settings.custrecord_order_items_selection.split("\n");
      this.title = settings.custrecord_merchant_title || "";
      this.isCarousel = settings.custrecord_merchant_carousel === "T";
      this.fullUrl = "";
      this.fullUrl = settings.custrecord_merch_url_path || false;
      this.originalItems = [];
      var isMobile = window.innerWidth < 768;
      if (this.isCarousel) {
        this.itemsPerPage = 4; // carousel uses 4 items per page
        if (isMobile) {
          this.itemsPerPage = 2; // mobile carousel uses 2 items per page
        }
      }
      this.cart = this.application.getComponent("Cart");
      this.items = [];
      var self = this;
      if (this.orderItems.length > 1 || this.commerceCategory) {
        this.model
          .fetch({
            data: {
              itemList: !self.commerceCategory ? self.orderItems.join(",") : "",
              commerceCategory: self.commerceCategory || "",
              limit: self.commerceCategory ? 12 : "",
            },
          })
          .done(function (resp) {
            if (self.commerceCategory && !self.fullUrl) {
              self.fullUrl = resp.data.fullUrl;
              var internalIds = _.map(
                resp.data.categoryResults,
                function (item) {
                  return item.internalid;
                },
              );
              // Create mapping of internalid to sequenceNumber
              var sequenceMap = {};
              _.each(resp.data.categoryResults, function (item) {
                sequenceMap[Number(item.internalid)] =
                  Number(item.sequenceNumber) || 0;
              });
            } else {
              var internalIds = _.map(resp.data, function (item) {
                return item.internalid;
              });
            }
            self.itemModel
              .fetch({
                data: {
                  id: internalIds.join(","),
                },
              })
              .done(function (resp) {
                self.items = _.map(resp.items, function (item) {
                  var image = item.custitem_item_image_full || "";
                  // if (item.itemid == "72065") {
                  //   debugger;
                  // }
                  if (item.outofstockbehavior !== "- Default -") {
                    item.isBackOrdered = true;
                  }
                  if (!image) {
                    image =
                      item.itemimages_detail &&
                      item.itemimages_detail.media &&
                      item.itemimages_detail.media.urls &&
                      item.itemimages_detail.media.urls[0] &&
                      item.itemimages_detail.media.urls[0].url;
                    if (!image) {
                      image =
                        item.itemimages_detail[item.mpn] &&
                        item.itemimages_detail[item.mpn].urls &&
                        item.itemimages_detail[item.mpn].urls[0] &&
                        item.itemimages_detail[item.mpn].urls[0].url;
                    }
                  }
                  // Current (online) price the customer actually pays
                  var onlinePrice =
                    item.onlinecustomerprice_detail &&
                    item.onlinecustomerprice_detail.onlinecustomerprice;
                  var onlinePriceFormatted =
                    item.onlinecustomerprice_detail &&
                    item.onlinecustomerprice_detail
                      .onlinecustomerprice_formatted;

                  // Base price (price level 1) — shown crossed out only when it's actually higher
                  var basePrice = item.pricelevel1;
                  var basePriceFormatted = item.pricelevel1_formatted;
                  var hasOldPrice =
                    typeof basePrice === "number" &&
                    typeof onlinePrice === "number" &&
                    basePrice - onlinePrice > 0.009;

                  return {
                    id: item.itemid,
                    internalid: item.internalid,
                    name: item.storedisplayname2 || item.displayname,
                    isConfigurable: !!item.custitem_option1description,
                    thumbnail:
                      image ||
                      "https://www.all-wall.com/scs/img/no_image_available.jpg",
                    url: item.urlcomponent,
                    priceformatted: onlinePriceFormatted,
                    price: onlinePrice,
                    oldprice: hasOldPrice ? basePrice : null,
                    oldpriceformatted: hasOldPrice ? basePriceFormatted : "",
                    hasOldPrice: hasOldPrice,
                    isBackOrdered: item.isBackOrdered,
                  };
                });
                // make a deep copy of items
                self.originalItems = JSON.parse(JSON.stringify(self.items));

                if (self.commerceCategory) {
                  self.items = _.sortBy(self.items, function (item) {
                    return sequenceMap[item.internalid] || 0;
                  });
                  // reverse the order if the sequence number
                  self.items = self.items.reverse();
                  self.items = self.items.slice(0, 8);
                }

                if (self.orderItems.length > 0 && !self.commerceCategory) {
                  // reodder items based on orderItems. OrderItems is a list of itemids
                  self.items = _.sortBy(self.items, function (item) {
                    // find the index of the item in orderItems
                    var index = self.orderItems.indexOf(item.id);
                    // if not found, return a high number to push it to the end
                    return index === -1 ? Number.MAX_VALUE : index;
                  });
                }
                // calculate total pages
                self.totalPages =
                  Math.ceil(self.items.length / self.itemsPerPage) || 1;
                // reset to first page if out of range
                if (self.currentPage > self.totalPages) {
                  self.currentPage = self.totalPages;
                }
                self.render();
              });
          });
      }

      return this._install(settings, context_data);
    },

    initHeroCarousel: function initHeroCarousel() {
      var $c = $("#your-carousel-id"); // hero container selector
      if (!$c.length || !$c.find(".item").length) {
        return false;
      }

      if (!$c.find(".item.active").length) {
        $c.find(".item").first().addClass("active");
        $c.find(".carousel-indicators li").first().addClass("active");
      }
      $c.carousel(0); // force to slide 0 and set the internal index
      return true;
    },

    events: {
      'click [data-action="add-to-cart-custom"]': "addItemToCart",
      'click [data-action="go-to-page"]': "goToPage",
      'click [data-action="prev-page"]': "prevPage",
      'click [data-action="next-page"]': "nextPage",
      'change [data-action="change-items-per-page"]': "changeItemsPerPage",
      "click [data-action='show-more-items']": "showMoreItems",
      // Add these touch events for swipe
      "touchstart .items-wrapper": "handleTouchStart",
      "touchmove .items-wrapper": "handleTouchMove",
      "touchend .items-wrapper": "handleTouchEnd",
    },

    // Add the new swipe handler functions
    handleTouchStart: function (e) {
      // Note: We use originalEvent to access native touch properties
      this.touchStartX = e.originalEvent.touches[0].clientX;
      this.touchStartY = e.originalEvent.touches[0].clientY;
    },

    handleTouchMove: function (e) {
      if (!this.touchStartX || !this.touchStartY) {
        return;
      }
      this.touchEndX = e.originalEvent.touches[0].clientX;
      this.touchEndY = e.originalEvent.touches[0].clientY;

      var deltaX = this.touchEndX - this.touchStartX;
      var deltaY = this.touchEndY - this.touchStartY;

      // If dragging more horizontally than vertically, prevent page scroll
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        e.preventDefault();
        // Apply visual slide effect
        this.$(".grid-items-merchant").css(
          "transform",
          "translateX(" + deltaX + "px)",
        );
      }
    },

    handleTouchEnd: function (e) {
      // Always reset the transform to snap back or prepare for re-render
      this.$(".grid-items-merchant").css("transform", "");

      if (!this.touchStartX || !this.touchEndX) {
        return;
      }

      var swipeThreshold = 50; // Minimum distance in pixels for a swipe
      var deltaX = this.touchEndX - this.touchStartX;
      var deltaY = this.touchEndY - this.touchStartY;

      if (
        Math.abs(deltaX) > swipeThreshold &&
        Math.abs(deltaX) > Math.abs(deltaY)
      ) {
        e.preventDefault();
        if (deltaX < 0) {
          // Swiped left
          this.nextPage(e);
        } else {
          // Swiped right
          this.prevPage(e);
        }
      }

      // Reset coordinates
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
    },

    showMoreItems: function (e) {
      e.preventDefault();
      Backbone.history.navigate(this.fullUrl, { trigger: true });
    },

    changeItemsPerPage: function (e) {
      e.preventDefault();
      // get the value from the select
      var itemsPerPage = parseInt(jQuery(e.target).val(), 10);
      if (itemsPerPage && itemsPerPage !== this.itemsPerPage) {
        this.itemsPerPage = itemsPerPage;
        this.currentPage = 1; // reset to first page

        this.totalPages = Math.ceil(this.items.length / this.itemsPerPage) || 1;
        // reset to first page if out of range
        if (this.currentPage > this.totalPages) {
          this.currentPage = this.totalPages;
        }
        this.render();
      }
    },

    addItemToCart: function (e) {
      /* unchanged */
      e.preventDefault();
      var internalid = jQuery(e.target).data("item-id");
      var self = this;
      this.cart
        .addLine({
          line: {
            quantity: 1,
            item: { internalid: internalid },
          },
        })
        .then(function () {
          var item = _.find(self.items, function (item) {
            return item.internalid === internalid;
          });
          self.cart.getLines().then(function (lines) {
            var line = _.find(lines, function (line) {
              return line.item.internalid === internalid;
            });
            if (line) {
              item.quantity = line.quantity;
            }
            var updateView = new CustomMerchantZoneConfirmationView({
              application: self.application,
              item: item,
            });

            self.application.getLayout().showInModal(updateView);
          });
        });
    },

    // Jump to a specific page
    goToPage: function (e) {
      e.preventDefault();
      var page = parseInt(jQuery(e.target).data("page"), 10);
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.render();
        // scroll to top of zone?
      }
    },

    prevPage: function (e) {
      e.preventDefault();
      if (this.currentPage > 1) {
        this.currentPage--;
        this.render();
      }
    },

    nextPage: function (e) {
      e.preventDefault();
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.render();
      }
    },

    getContext: function getContext() {
      // compute slice
      var start = (this.currentPage - 1) * this.itemsPerPage;
      var end = start + this.itemsPerPage;
      var pageItems = this.items.slice(start, end);

      // === begin pagination window logic ===
      var maxToShow = 5; // <-- maximum links you want visible
      var total = this.totalPages;
      var current = this.currentPage;
      var nums = [];

      if (total <= maxToShow) {
        // if few pages, just list them all
        for (var i = 1; i <= total; i++) {
          nums.push(i);
        }
      } else {
        // always show page 1
        nums.push(1);

        if (current <= maxToShow - 1) {
          // near the start → show pages 2..maxToShow
          for (var i = 2; i <= maxToShow; i++) {
            nums.push(i);
          }
        } else if (current > total - (maxToShow - 1)) {
          // near the end → show the last maxToShow pages
          for (var i = total - (maxToShow - 1); i <= total; i++) {
            nums.push(i);
          }
        } else {
          // middle → show current..current+(maxToShow-2)
          // e.g. at current=5 → pushes 5,6,7,8
          for (var i = current; i <= current + (maxToShow - 2); i++) {
            nums.push(i);
          }
        }
      }

      // build the final pages array your template expects
      var pages = _.map(nums, function (p) {
        return {
          page: p,
          isCurrent: p === current,
        };
      });
      // === end pagination window logic ===

      var start = (this.currentPage - 1) * this.itemsPerPage;
      var end = start + this.itemsPerPage;
      var pageItems = this.items.slice(start, end);

      var pages = _.map(nums, function (p) {
        // ...
      });
      // === end pagination window logic ===

      // === ADD THIS LOGIC to create the bubbles array ===
      var bubbles = [];
      for (var i = 1; i <= this.totalPages; i++) {
        bubbles.push({
          page: i,
          isCurrent: i === this.currentPage,
        });
      }

      return {
        title: this.title,
        bubbles: bubbles, // <-- Add the new bubbles array to the context
        items: pageItems,
        currentPage: this.currentPage,
        totalPages: this.totalPages,
        hasPrev: this.currentPage > 1,
        hasNext: this.currentPage < this.totalPages,
        pages: pages,
        showPagination: this.totalPages > 1 && !this.isCarousel,
        twelveSelected: this.itemsPerPage === 12,
        twentyFourSelected: this.itemsPerPage === 24,
        fortyEightSelected: this.itemsPerPage === 48,
        isCarousel: this.isCarousel,
        isCommerceCategory: !!this.commerceCategory,
        fullUrl: this.fullUrl,
        showButton: !!this.fullUrl,
      };
    },
  });
});
